// import { createSlice } from "@reduxjs/toolkit";

// const authSlice = createSlice({
//   name: "auth",
//   initialState: {
//     user: localStorage.getItem("userStatus") ? JSON.parse(localStorage.getItem("userStatus")) : null,
//     profile:null,
//     error: null,
//     loading: false,
//     token: null,
//     tokenExp: null,
//     isLoggedIn: localStorage.getItem("loginStatus") ? localStorage.getItem("loginStatus") : false,
//   },
//   reducers: {
//     loginStart: (state) => {
//       state.loading = true;
//       state.error = null;
//     },
//     setProfile:(state,action)=>{
//       state.profile=action.payload
//     },
//     loginSuccess: (state, action) => {
//       state.loading = false;
//       state.user = action.payload.user;
//       state.token = action.payload.token;
//       state.tokenExp = action.payload.exp

//       localStorage.setItem("userStatus", JSON.stringify(action.payload.user));
//       localStorage.setItem("loginStatus", true);
//       localStorage.setItem("authToken", action.payload.token)
//       localStorage.setItem("tokenExp", action.payload.exp)
//     },
//     loginFailure: (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     logout: (state) => {
//       state.user = null;
//       localStorage.removeItem("userStatus");
//       state.profile=null;
//       state.error = null;
//       state.loading = false;
//       state.token = null
//       state.tokenExp = null
//       localStorage.removeItem("loginStatus");
//       localStorage.removeItem("accion");
//       localStorage.removeItem("accionSSHH");
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("tokenExp");

//     }
//   },
// });

// export const { loginStart, loginSuccess, loginFailure, logout,setProfile, deleteToken } = authSlice.actions;

// export default authSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

// Función para obtener datos de localStorage solo en el cliente
const getFromLocalStorage = (key, defaultValue = null) => {
  if (typeof window !== "undefined") {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  }
  return defaultValue;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: getFromLocalStorage("userStatus"), // Cargar solo en el cliente
    profile: null,
    error: null,
    loading: false,
    token: null,
    tokenExp: null,
    isLoggedIn: getFromLocalStorage("loginStatus", false), // Manejar booleano por defecto
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.tokenExp = action.payload.exp;

      if (typeof window !== "undefined") {
        // Guardar en localStorage solo en el cliente
        localStorage.setItem("userStatus", JSON.stringify(action.payload.user));
        localStorage.setItem("loginStatus", JSON.stringify(true));
        localStorage.setItem("authToken", action.payload.token);
        localStorage.setItem("tokenExp", action.payload.exp);
      }
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.profile = null;
      state.error = null;
      state.loading = false;
      state.token = null;
      state.tokenExp = null;

      if (typeof window !== "undefined") {
        // Eliminar de localStorage solo en el cliente
        localStorage.removeItem("userStatus");
        localStorage.removeItem("loginStatus");
        localStorage.removeItem("authToken");
        localStorage.removeItem("tokenExp");
      }
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, setProfile } = authSlice.actions;

export default authSlice.reducer;
